import type * as ptChrome from '../pt/chrome';

/** English mirror of `../pt/chrome.ts`; each export is checked against its pt twin. */
export const common: typeof ptChrome.common = {
  loading: 'Loading…',
  search: 'Search',
  save: 'Save',
  cancel: 'Cancel',
  edit: 'Edit',
  delete: 'Delete',
  remove: 'Remove',
  add: 'Add',
  close: 'Close',
  back: 'Back',
  confirm: 'Confirm',
  all: 'All',
  none: 'None',
  yes: 'Yes',
  no: 'No',
  clear: 'Clear',
  apply: 'Apply',
  noResults: 'No results.',
  error: 'Something went wrong.',
};

export const roles: typeof ptChrome.roles = {
  admin: 'Administration',
  manager: 'Management',
  researcher: 'Researcher',
  direction: 'Board',
  collaborator: 'Collaborator',
};

export const modules: typeof ptChrome.modules = {
  colaboradores: 'Collaborators',
  onboarding: 'Onboarding',
  rh: 'HR',
  safelab: 'SafeLab',
  permissoes: 'Permissions',
  activeDirectory: 'Active Directory',
  definicoes: 'Settings',
  dashboard: 'Dashboard',
  viaturas: 'Vehicles',
  equipa: 'Research Teams',
  artigos: 'Scientific Output',
  presencas: 'Attendance Record',
};

export const moduleHints: typeof ptChrome.moduleHints = {
  colaboradores: 'Manage the collaborator records.',
  onboarding: 'Invites and review of new collaborators.',
  rh: 'Human Resources.',
  safelab: 'Laboratory health and safety.',
  permissoes: 'Grant module access.',
  activeDirectory: 'AD account provisioning.',
  definicoes: 'Portal configuration (fields, integrations).',
  dashboard: 'Portal overview.',
  viaturas: 'Vehicles and parking spaces.',
  equipa: 'Research Teams and Thematic Lines (SISTRADE).',
  artigos: 'Scientific output (articles) via Scopus/Elsevier.',
  presencas: 'Daily attendance records (internal API or database).',
};

export const shell: typeof ptChrome.shell = {
  brandSub: 'Institutional management',
};

export const topbar: typeof ptChrome.topbar = {
  menu: 'Menu',
  searchTitle: 'Search (Ctrl+K)',
  lightMode: 'Light mode',
  darkMode: 'Dark mode',
  toggleTheme: 'Toggle theme',
  logout: 'Sign out',
  language: 'Language',
  switchToEnglish: 'Switch to English',
  switchToPortuguese: 'Mudar para Português',
};

export const nav: typeof ptChrome.nav = {
  painel: 'Dashboard',
  meuPerfil: 'My Profile',
  registos: 'Records',
  convites: 'Invites',
  novoRegisto: 'New Record',
  it: 'IT administration',
  sections: {
    essentials: 'Essentials',
    pessoas: 'People',
    onboarding: 'Onboarding',
    investigacao: 'Research',
    laboratorio: 'Laboratory',
    sistema: 'System',
  },
  settings: {
    global: 'Global Configuration',
    campos: 'Record Fields',
    painel: 'Dashboard',
    integracao: 'SISTRADE Integration',
  },
};

export const notifications: typeof ptChrome.notifications = {
  title: 'Notifications',
  empty: 'No notifications. 🎉',
};

export const attendance: typeof ptChrome.attendance = {
  title: 'Attendance Record',
  subtitle: 'Daily attendance of collaborators',
  chip: {
    off: 'Not configured',
    configured: 'Connection configured',
    linked: 'Linked',
  },
  prepared: {
    title: 'Module ready',
    body: 'The structure is ready to read records from an internal API or database. All that is missing is the identifier that links each collaborator to their daily records — it will be configured once available.',
  },
  records: {
    title: 'Records',
    empty: 'No records to show.',
  },
  table: {
    date: 'Date',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    status: 'Status',
  },
};

export const impersonation: typeof ptChrome.impersonation = {
  bannerPrefix: 'Viewing the app as',
  bannerActor: 'session started by {name}',
  stop: 'Stop',
};

export const cmd: typeof ptChrome.cmd = {
  aria: 'Search',
  placeholder: 'Search modules, pages…',
  empty: 'Nothing found.',
  hintNavigate: 'navigate',
  hintOpen: 'open',
  hintClose: 'close',
};

export const status: typeof ptChrome.status = {
  pendingReview: 'Pending review',
  changesRequested: 'Changes requested',
  approved: 'Approved',
  launchedInSistrade: 'Launched in SISTRADE',
  rejected: 'Rejected',
  source: {
    manager: 'Manager',
    selfRegistration: 'Invite',
  },
  invite: {
    pending: 'Pending',
    submitted: 'Submitted',
    cancelled: 'Cancelled',
    expired: 'Expired',
  },
  delivery: {
    email: 'Email',
    link: 'Link',
    code: 'Code',
  },
};

export const tabbar: typeof ptChrome.tabbar = {
  collaborator: 'Collaborator',
  record: 'Record',
};

export const shared: typeof ptChrome.shared = {
  noData: 'No data.',
  noResults: 'No results.',
  active: 'Active',
  inactive: 'Inactive',
  customCardsHeading: 'Scientific Output',
};

export const bilingual: typeof ptChrome.bilingual = {
  pt: 'Portuguese',
  en: 'English',
  translate: 'Translate',
  translating: 'Translating…',
  unconfigured: 'Automatic translation is not configured — fill in English by hand.',
  failed: 'Could not translate automatically.',
};
